export function getSymbolIsin(symbol): string {
  return (
    symbol.instrumentIsin || symbol.isin || symbol.instrumentIdentification
  );
}
